import { createContextStoreWithRuntimeModel } from '../helpers/context-store.helpers';
import { GlobalEcommerceSettingsStore } from './global-ecommerce-settings.types';

export const GlobalEcommerceSettingsContext = createContextStoreWithRuntimeModel<GlobalEcommerceSettingsStore>(
    (runtimeModel) => ({
        settings: runtimeModel?.settings,
    }),
    { name: 'GlobalEcommerceSettingsContext' }
);
